import CryptoJS from 'crypto-js'

export const encryption = form => {
  const { data, encryptArr } = form
  let key = '201603152020BABC'
  let iv = 'BABC202003152016'
  // const encryptArr = ['password']
  // const type = ''
  const result = JSON.parse(JSON.stringify(data))
  // if (type === "Base64") {
  //   encryptArr.forEach(ele => {
  //     result[ele] = btoa(result[ele])
  //   })
  // } else {
  encryptArr.forEach(ele => {
    const encryptStr = result[ele]
    key = CryptoJS.enc.Latin1.parse(key)
    iv = CryptoJS.enc.Latin1.parse(iv)
    // 加密
    const encrypted = CryptoJS.AES.encrypt(encryptStr, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })
    result[ele] = encrypted.toString()
  })
  // }
  return result
}
